export default "__VITE_ASSET__oWx7gsIm__"